// Function to handle the scroll event
function handleScroll() {
  var elements = document.getElementsByClassName('bl-content');
  var mainContentSection = document.querySelector('.bl-product-usp-container');
  var scrollPosition = window.scrollY + window.innerHeight;
  var sectionOffset = mainContentSection.offsetTop;
  var sectionHeight = mainContentSection.offsetHeight;
  var scrollThreshold = sectionOffset + (sectionHeight * 0.08);

  if (scrollPosition > scrollThreshold) {
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.add('bl-fade-in-up');
    }
  }
}

// Add scroll event listener
window.addEventListener('scroll', handleScroll);
